import { unref } from 'vue';
import { resolveModalTeleportTarget, type ModalTeleportTarget } from '../../ideo/ui-modal/teleportTarget';

export type ConfirmationTeleportTarget = ModalTeleportTarget;

function resolveTargetElement(target: any)
{
    const value = unref(target);

    if (typeof value === 'string')
    {
        return document.querySelector(`[id="${value}"]`) as HTMLElement | null;
    }

    if (value?.$el)
    {
        return value.$el;
    }

    return value;
}

export function resolveConfirmationTeleportTarget(target: any)
{
    const element = resolveTargetElement(target);

    return resolveModalTeleportTarget(element);
}
